module.exports = __webpack_public_path__ + "img/image11.8f59deb8.png";